import { httpClient } from '../../../../../../common/utils/httpClient';

export const shouldOpenPlayground = (urlFormat, location) => {
  const urlParams = new URLSearchParams(location.search);
  const isPlaygroundOpen = !!urlParams.get('isPlaygroundOpen');
  const currentMethodName = location.pathname.split('/').pop();
  return isPlaygroundOpen && currentMethodName === urlFormat;
};

export const getPlaygroundParamsFromQuery = (location) => {
  const urlParams = new URLSearchParams(location.search);

  const outputObject = {};

  if (urlParams.get('queryParams')) {
    outputObject.queryParams = JSON.parse(
      decodeURIComponent(urlParams.get('queryParams')),
    );
  }

  if (urlParams.get('pathParams')) {
    outputObject.pathParams = JSON.parse(
      decodeURIComponent(urlParams.get('pathParams')),
    );
  }

  if (urlParams.get('body')) {
    outputObject.body = decodeURIComponent(urlParams.get('body'));
  }

  return outputObject;
};

const getFryingpanMappings = (fullArtifactId, url) =>
  fullArtifactId &&
  httpClient
    .get(
      `${
        window.location.origin
      }/_serverless/wix-docs-fryingpan-endpoints?originalEndpointFromYaml=${encodeURIComponent(
        url,
      )}&artifactId=${fullArtifactId}`,
      {},
    )
    .then((res) => res.data);

export const fetchFryingpanMappings = ({
  artifactId,
  setLoading,
  operation,
  setFryingpanEndpoints,
}) => {
  const url = operation && operation.docs && operation.docs.url;
  setLoading(true);
  return getFryingpanMappings(artifactId, url)
    .then((_fryingpanEndpoints) => {
      setFryingpanEndpoints(_fryingpanEndpoints);
      setLoading(false);
    })
    .catch((error) => {
      console.error(error);
      setLoading(false);
    });
};
